module.exports = {
	"abort_transformation": "Annuler la transformation",
	"actions": "Actions",
	"activity": "Activité",
	"add_layer": "Ajouter un calque",
	"add_new_text_element": "Ajouter du texte",
	"add_to_collection": "Ajouter à une collection",
	"add_to_dashboard": "Ajouter au tableau de bord",
	"admin": "admin",
	"advanced": "Avancées",
	"aggregation_method": "Meéthode d'agrégation",
	"aggregation_type": "Type d’agrégation",
	"aggregation": "Agrégation",
	"akvo_flow": "Akvo Flow",
	"akvo_rsr": "Akvo RSR",
	"all_changes_saved": "Changements sauvegardés",
	"all": "Tout",
	"antimeridian": "antiméridien",
	"apply": "Appliquer",
	"area": "Aire",
	"ascending": "Ascendant",
	"authentication_issue": "Un problème est survenu lors de la vérification de votre identité",
	"autodetect_column_types": "Detecter automatiquement le type de colonne",
	"average": "Moyenne",
	"back_to_layers": "Revenir aux calques",
	"back": "Revenir",
	"bar": "Histogramme",
	"base_map": "Carte de base",
	"blank_dashboard_help_text": "Cliquez une visualisation dans la liste pour l'ajouter au tableau de bord",
	"bottom": "Bas",
	"bubble": "Bubble",
	"bucket_column": "Colonne contenant",
	"bulk_column_editor": "Editeur multi-colonne",
	"bulk_row_editor": "Editeur multi-rangée",
	"cancel": "Annuler",
	"categories_cant_be_empty": "Les catégories ne peuvent pas être vides",
	"categories_count": "{count} {count, plural, one {catégorie} other {catégories}}",
	"categories_must_be_unique": "Cette catégorie est existente",
	"category": "Catégorie",
	"cell_as_percentage_of_column": "Cellule en pourcentage de la colonne",
	"cell_as_percentage_of_row": "Cellule en pourcentage de la rangée",
	"cell_as_percentage_of_table_total": "Cellule en pourcentage du total",
	"change_case": "Changer la casse",
	"change_datatype_for": "Change le type de donnée pour {title}",
	"change_datatype_to": "Change le type de donnée vers",
	"choose_a_column_to_filter_by": "Colonne à filtrer par",
	"choose_a_filter_operation": "Choisir une opération de filtrage",
	"choose_a_match_method": "Méthode de correspondance de filtre",
	"choose_aggregation_type": "Choisissez le type d'agrégation",
	"choose_dataset": "Choisir le jeu de données",
	"choose_how_cells_are_displayed": "Choisissez comment les cellules sont affichées",
	"circle": "Cercle",
	"clear_filter": "Effacer les filtres",
	"close": "Fermer",
	"collection_name": "Nom de collection",
	"collections": "Collections",
	"color_coding_column": "Colonne de code couleur",
	"color": "Couleur",
	"colors_for_title": "Couleurs ({title})",
	"column_filter_by": "Colonne à filtrer par",
	"column_title_geo": "Titre de colonne de location",
	"columns_title": "titre de colonne",
	"columns": "colonnes",
	"combine_columns": "Joindre les colonnes",
	"combine_transform_description": "Joindre colonnes {firstTitle} et {secondTitle} vers \"{newColumnTitle}\"",
	"combine": "Joindre",
	"comma": "virgule",
	"contact": "Contact",
	"contains": "contains",
	"count_unique": "Nombre unique",
	"count": "Compte",
	"create_visualization": "Créer une visualisation",
	"create": "Créer",
	"created_by": "Ajouté par",
	"creating": "Créer",
	"dashboard": "Tableau de bord",
	"dashboards": "Tableaux de bord",
	"data_file": "fichiers de donnée",
	"data_group_intro_0_body": "Les ensembles de données sont désormais divisés en groupes de données pour faciliter le nettoyage et la transformation de vos données. Obtenez une meilleure vue d'ensemble quel que soit le côté de l'ensemble de données. Un groupe de données dédié contient toutes les colonnes transformées pour garder les choses organisées.",
	"data_group_intro_0_footer": "À l'avenir, cette nouvelle vue prendra en charge les données de groupes de données répétés et deviendra la valeur par défaut.",
	"data_group_intro_0_header": "Découvrez la nouvelle vue d'ensemble de données",
	"data_group_intro_1": "Les groupes de données sont basés sur les groupes de questions du formulaire Flow et les métadonnées de soumission. Lumen gère toutes les relations de données entre les groupes lors de la transformation et de la visualisation des données.",
	"data_group_intro_2": "Sélectionnez n'importe quel groupe de données pour afficher ses données sur la grille.",
	"data_group_intro_3": "Vous pouvez basculer entre la nouvelle et l'ancienne vue ici.",
	"data_groups": "Groupes de Données",
	"data_has_column_headers": "Données ",
	"data_last_updated": "Données mises à jour à",
	"data": "Donnée",
	"dataset_filters": "Filtres de données",
	"dataset_name": "Nom de jeu de données",
	"dataset": "Source de données",
	"datasets": "Sources de données",
	"date": "Date",
	"default": "Défaut",
	"delete_column": "Supprimez colonne",
	"delete_row": "Supprimez rangée",
	"delete": "Supprimer",
	"deleted_column": "Colonne supprimée: {title}",
	"derive_column_category": "Colonne de catégorie (TEXTE)",
	"derive_column_javascript": "Via JavaScript",
	"derive_column": "Dériver une colonne",
	"derive": "Dériver",
	"derived_category_transform_description": "Dérivée \"{newColumnTitle}\" de {columnSource} ({columnType})",
	"derived_column_title": "Titre de colonne dérivé",
	"derived_transform_description": "Dériver {newColumnTitle} utilisant {code}",
	"descending": "Descendant",
	"donut": "Anneau",
	"download": "Telecharger",
	"drop_file_anywhere": "Déposez le fichier pour l'envoyer",
	"dropbox": "Dropbox",
	"duplicate": "Dupliquer",
	"email_verified_error": "Vous devez vérifier votre adresse e-mail. Vérifiez votre boîte de courrier electronique et cliquez sur le lien de vérification",
	"email": "Couriel",
	"enter_a_number": "Entrez un nombre",
	"enter_password_8": "Votre mot de passe doit contenir un minimum de 8 caractères.",
	"enter_password": "Entrez un mot de passe.",
	"enter_text_here": "Entrez le texte ici",
	"exactly_matches": "Correspond exactement",
	"export": "Exporter",
	"extract_multiple_global_error": "Oups, une erreure est survenue, contactez votre administrateur",
	"extract_multiple_log": "Extraire plusieurs valeurs de: {extractedColumnTitle} à: {newColumnsTitle}",
	"extract_multiple_not_found_error": "Il y’a un problème avec les données à l’intérieur de cette colonne multiple",
	"extract_multiple": "Extraire plusieurs valeurs",
	"extract": "Extrait",
	"file_has_column_headers": "File has column headers",
	"file_name": "Nom de fichier",
	"file_project": "Fichier / Projet",
	"fill": "Remplir",
	"filter_column": "Filtrer colonne {title}",
	"filter_list_by_title": "Filtrer liste par titre",
	"filter_match_method": "Méthode de correspondance de filtre",
	"filter_match_value": "Valeur de correspondance du filtre",
	"filter_operation": "Opération de filtrage",
	"filter_text": "Filtrer texte",
	"filter_visualisations_by_dataset": "Filtrer les visualisations par données",
	"filter": "Filtre",
	"filters": "Filtres",
	"first_name": "Prénom",
	"flow_application_url": "Flow Application URL",
	"following_filter_dash_will_be_deleted": "Ce tableau de bord ne sera plus filtré par le jeu de données supprimé",
	"following_filters_dash_will_be_deleted": "Ces tableaux de bord  ne seront plus filtrés par le jeu de données supprimé",
	"following_visualisation_will_be_deleted": "La visualisation suivante sera également supprimée",
	"following_visualisations_will_be_deleted": "Les visualisations suivantes seront également supprimées",
	"form_submissons": "formulaires envoyés",
	"generate_geopoints": "Generer point de location",
	"generate": "Generer",
	"geo_location": "Geo location",
	"geo_shape": "Forme geographique",
	"geo_transform_description": "Colonne de location {columnTitleGeo} generée depuis colonnes {columnTitleLat} et {columnTitleLong}",
	"geopoint_column": "Colonne géopoint",
	"geopoint": "Géopoint",
	"geoshape_column": "Colonne géoshape",
	"geoshape_labels": "Etiquettes géoshape",
	"geoshape": "Forme geographique",
	"geotiff": "GeoTIFF",
	"github": "Github",
	"google_drive": "Google Drive",
	"got_it": "J'ai compri",
	"gradient": "Gradient",
	"greenwich": "Greenwich",
	"group": "Groupe",
	"having_trouble_signing_up": "Avoir du mal à s'inscrire?",
	"hyphen": "Trait d'union",
	"if_cell_format_is_invalid": "Si le format de cellule est invalide",
	"if_transformation_fails": "Si la transformation echoue",
	"Image": "Image",
	"import": "Importer",
	"invalid_expression": "Expression invalide",
	"invalid_filter": "Cette visualisation contient un filtre invalide et ne peut être affichée.",
	"is_after": "est après",
	"is_before": "est avant",
	"is_empty": "est vide",
	"is_equal_to": "est égal à",
	"is_greater_or_equal_to": "est supérieur ou égal à",
	"is_greater_than": "est supérieur à",
	"is_higher_than": "est plus supérieur à",
	"is_less_or_equal_to": "est inférieur ou égal à",
	"is_less_than": "est inférieur à",
	"is_lower_than": "est plus inférieur à",
	"javascript_code": "Code javascript",
	"js_helptext": "Les colonnes dérivées sont des formules écrites en utilisant un sous-ensemble de Javascript où une seule expression est autorisée et les colonnes sont référencées comme {columnSyntax} ou, en variante, si le titre est un identifiant de javascript valide: {title}.",
	"keep_rows_in_which": "Garder les lignes dans lesquelles",
	"label": "Étiquette",
	"last_modified": "Modifié",
	"last_name": "Nom",
	"latitude_column": "Colonne de latitude",
	"layer_type": "Type de calque",
	"layers": "Calques",
	"leave_cell_empty": "Laisser la cellule vide",
	"left": "Gauche",
	"legend_category_order": "Ordre de catégorie",
	"legend_order_auto_mode": "Automatique",
	"legend_order_custom_mode": "Custom",
	"legend_position_auto": "Automatique",
	"legend_position_bottom": "En bas",
	"legend_position_left": "À gauche",
	"legend_position_right": "À droite",
	"legend_position_top": "En haut",
	"legend_position": "La position de la légende ",
	"legend_title": "Titre de la légende",
	"legend": "Légende",
	"library": "Librairie",
	"line": "ligne",
	"link": "Lien",
	"logout": "se déconnecter",
	"longitude_column": "Colonne de longitude",
	"lower_quartile": "Quartile inférieur",
	"main": "Principal",
	"map": "Carte",
	"max_value": "Max: {val}",
	"max": "Max",
	"mean": "Moyenne",
	"median": "Médiane",
	"merge_datasets": "Fusionner les jeux de données",
	"merged_dataset": "Fusionner les colonnes depuis {title}",
	"metadata": "Métadonnées",
	"metric_column": "Colonne métrique",
	"metric_columns": "Colonnes métriques",
	"min_value": "Min: {val}",
	"min": "Min",
	"misc": "Autres options",
	"multiple": "Multiple valeurs",
	"must_choose_bucket_column_first": "Doit choisir la colonne contenant d'abord",
	"must_choose_x_axis_column_first": "Doit choisir l'axe-x d'abord",
	"name": "Nom",
	"new_category_column": "Nouvelle Colonne de catégorie",
	"new_collection": "Nouvelle collection",
	"new_column_title": "Nouveau titre de colonne",
	"new_column_type": "Nouveau type de colonne",
	"new_dataset": "Nouveau jeu de données",
	"new_filter": "Nouveau filtre",
	"new_serie": "Nouvelle série",
	"next": "Suivant",
	"no_filter_dashboards_depend_on_dataset": "Aucun tableau de bord de filtres ne dépend de cet ensemble de données",
	"no_visualisations_depend_on_dataset": "Aucune visualisation ne dépend de cet ensemble de données",
	"no_visualisations_match_your_filter": "Pas de visualisation avec vos filtres",
	"no_visualisations_to_show": "Pas de visualisation à montrer",
	"none": "Aucun",
	"not_affected_by_applied_filters": "Not affected by applied filters",
	"not_contains": "not contains",
	"number_of_buckets_to_show": "Nombre de contenant à montrer",
	"number_of_decimal_places": "Nombre de decimales",
	"number": "Nombre",
	"or": "ou",
	"outline": "Contour",
	"overflow": "Débordement",
	"paste_url_here": "Coller l'url ici",
	"pattern_subtitle": "Spécifiez n’importe quel caractère (ou chaîne de caractères) pour fractionner la colonne.",
	"pattern_suggestion": "Suggestions pour '{columnTitle}': {recommendations}",
	"pattern": "Séparateur",
	"pdf": "PDF",
	"pending": "En attendant",
	"percentage_stack_bars": "Pourcentage de barres empilées",
	"pick_a_default_value": "Entrez une valeur par défaut",
	"pie": "camembert",
	"pivot table": "Tableau croisé",
	"pivot_help_text": "Choisissez une colonne et une ligne à croiser pour utiliser des agrégations autres que le compte.",
	"please_edit_visualisation": "S'il vous plaît modifier la visualisation.",
	"png": "PNG",
	"point_size": "Taille de point",
	"polararea": "Polar Area",
	"popup_label_column": "Colonne de l'étiquette contextuelle",
	"popup_label": "Infos-bulle",
	"popup": "Fenêtre",
	"prefix": "Nouveau préfixe de colonne",
	"previous": "Precedent",
	"raster": "Raster",
	"remove_collection": "Retirer {title}",
	"remove_double_space": "Retirer double espace",
	"remove_leading_and_trailing_whitespace": "Retirer espace blanc avancé et en aval",
	"remove_rows_in_which": "Supprimer les lignes dans lesquelles",
	"removed_double_space": "{title} espace double supprimé",
	"rename_column": "Renommer colonne",
	"rename": "Renommer",
	"renamed_column": "Renommer {from} à {to}",
	"request_permission_from_your_organisation_admin": "Demander l’authorisation à votre administrateur.",
	"reselect_source_column": "Choisissez une autre colonne",
	"resources": "Resources",
	"retry": "Réessayer",
	"reverse_geocode": "Géocodage inversé",
	"right": "Droite",
	"role": "Role",
	"row_column_title": "Titre de la colonne en rangée",
	"row_column": "colonne rangée",
	"rows": "lignes",
	"rqg": "Multiple",
	"satellite": "Satellite",
	"save_filter": "Enregistrer le filtre",
	"save_your_dashboard_before_exporting": "Enregistrez votre tableau de bord avant d'exporter",
	"save_your_dashboard_before_sharing": "Sauvegarder votre tableau de bord avant de le partager",
	"save_your_visualisation_before_exporting": "Enregistrez votre visualisation avant de l'exporter",
	"save_your_visualisation_before_sharing": "Sauvegardez votre visualisation avant de la partager",
	"save": "Sauvegarder",
	"saving_failed_countdown": "Sauvegarde echouée. Essayant",
	"scatter": "Nuage de points",
	"search_not_implemented_yet": "Recherche non encore mise en œuvre",
	"search": "Recherche",
	"select_a_color_coding_column": "Sélectionnez une colonne de données à colorier",
	"select_a_column": "Sélectionnez une colonne",
	"select_a_data_column_to_group_by": "Sélectionnez une colonne de données à grouper",
	"select_a_geopoint_column": "Sélectionnez une colonnne de géopoint",
	"select_a_geoshape_column": "Sélectionnez colonne géoshape",
	"select_a_geoshape_label_column": "Sélectionnez une étiquette colonne géoshape",
	"select_a_latitude_column": "Sélectionnez une colonnne de latitude",
	"select_a_longitude_column": "Sélectionnez une colonnne de longitude",
	"select_a_metric_column": "Sélectionnez une colonne métrique",
	"select_a_popup_label_column": "Sélectionnez une colonne d'étiquette contextuelle",
	"select_a_row_column": "Sélectionnez une colonne de ligne",
	"select_a_styling_dataset": "Selectionnez un style de base de Données",
	"select_a_styling_indicator_geopoint_column": "Selectionnez un indicateur de style de colonne géopoint",
	"select_a_styling_indicator": "Selectionnez un indicateur de style",
	"select_a_sub_bucket_column": "Sélectionnez une colonne de sous-contenant",
	"select_a_value_column": "Selectionnez une colonne de valeures",
	"select_aggregation_method": "Sélectionner la méthode d'agrégation",
	"select_all": "Tout sélectionner",
	"select_another_metric_column": "Sélectionnez une autre colonne métrique",
	"select_column_lat": "Sélectionnez le colonnne de latitude",
	"select_column_long": "Selectionnez colonne de longitude",
	"select_form": "Sélectionnez le formulaire",
	"select_multiple_column": "Selectionnez colonne multiple",
	"select_n_column": "Sélectionnez {idx, selectordinal, one {#st} two {#nd}} colonne",
	"select_separator": "Sélectionnez le séparateur",
	"select_source_column": "Sélectionner la colonne source",
	"select_survey_or_folder": "Sélectionnez Enquête ou dossier",
	"select_values_to_extract": "Selectionnez valeurs à utiliser",
	"select_values_to_group": "Sélectionnez les valeurs à regrouper",
	"select": "Sélectionnez",
	"set_dataset_columns_as_visualisation_filters": "Définir des colonnes de données comme filtres de visualisation",
	"set_permissions": "Définir les autorisations",
	"settings": "Paramètres",
	"share": "Partager",
	"show_column_totals": "Afficher les totaux des colonnes",
	"show_labels": "Montrer étiquettes",
	"show_legend": "Montrer la légende",
	"show_row_totals": "Afficher les totaux des lignes",
	"show_rows_whose": "Afficher les lignes dont",
	"size_label": "Libellé de l’aire",
	"size": "Aire",
	"skip": "Sauter",
	"solid": "Solide",
	"sort": "Arrangez",
	"sorted_column": "{title} arranger {direction, select, ASC {ascending} DESC {descending}}",
	"source_column": "Colonne source",
	"source_dataset": "Source de données",
	"source": "Source",
	"split_bars": "Barres divisées",
	"split_bucket": "Conteneur de division",
	"split_column_log": "Fractionner la colonne '{extractedColumnTitle}', avec le préfixe '{newColumnNamePrefix}' avec le séparateur '{pattern}'",
	"split_column": "Valeurs de colonne Fractionnées",
	"square": "Carré",
	"stack_bars": "Barres d'empilement",
	"street": "Rue",
	"styling_dataset": "Style de base de Données",
	"styling_indicator_geopoint_column": "Indicateur de style de colonne géopoint",
	"styling_indicator": "Indicateur de style",
	"sub_bucket_column": "Colonne sous-contenant",
	"sub_bucket_method": "Méthode sous-contenant",
	"sum": "Somme",
	"switch_view": "Changer de vue",
	"terrain": "Terrain",
	"text": "Texte",
	"theme": "Thème",
	"to_lowercase_label": "En miniscule",
	"to_lowercase": "{title} en miniscule",
	"to_titlecase_label": "Capitaliser chaque mot",
	"to_titlecase": "Capitaliser chaque mot de {title}",
	"to_try_with_another_account": "essayer avec un autre compte",
	"to_uppercase_label": "En majuscule",
	"to_uppercase": "{title} en majuscule",
	"too_many_visualisation_elements": "Cette visualisation ne peut être afficher parce qu'elle contient {count} éléments. Le nombre maximum d'éléments est {max}",
	"top": "haut",
	"transform": "Transformer",
	"transformation_log": "Registre de transformation",
	"transformations": "Transformations",
	"triangle": "Triangle",
	"trimmed_whitespace": "{title} reduire espace",
	"type_javascript_expression_here": "Taper une expression javascript",
	"uncategorized_values": "Valeurs non classées",
	"uncategorized": "Non classé",
	"undo": "Défaire",
	"unique_values_count": "{count} {count, plural, one {valeur unique} other {valeurs uniques}}",
	"unsaved_changes": "Changements non sauvegardés",
	"untitled_collection": "Collection sans titre",
	"untitled_dashboard": "Tableau de bord sans titre",
	"untitled_layer": "Calque sans titre {count}",
	"untitled_visualisation": "Visualisation sans titre",
	"update": "Mise à jour",
	"upper_quartile": "Quartile supérieur",
	"user": "Utilisateur",
	"users": "Utilisateurs",
	"using_sampled_data": "Utilisant des données échantillonnées",
	"value_column": "Colonne de valeures",
	"value_contains": "la valeur contient",
	"value_display": "Value display",
	"value_is": "la valeur est",
	"view_details": "Afficher details",
	"visualisation_type": "Type",
	"visualisation": "Visualisation",
	"visualisations_that_can_be_filtered": "Visualisations pouvant être filtrées par jeu de données sélectionné",
	"visualisations": "Visualisations",
	"visualise": "Visualiser",
	"whitespace": "Espace",
	"world_bank": "World Bank",
	"x_axis_label": "Étiquette de l'axe des X",
	"x_axis": "Axe X",
	"y_axis_label": "Etiquette de l'axe des Y",
	"y_axis": "Axe Y",
	"yikes": "Beurk",
	"you_need_permission_to_access": "Vous devez être authoriser pour accéder"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr.json
// module id = 353
// module chunks = 11 12